"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var subsink_1 = require("./subsink");
exports.SubSink = subsink_1.SubSink;
//# sourceMappingURL=index.js.map